/* eslint-disable class-methods-use-this */
import axios from 'axios';

let logInstance = null;

const getHeaders = (traceId, accessToken) => {
  return {
    headers: {
      'x-amzn-trace-id': traceId,
      Authorization: accessToken,
    },
  };
};
class LogService {
  constructor(urls, traceId, accessToken) {
    this.infoUrl = urls.infoUrl;
    this.errorUrl = urls.errorUrl;
    this.traceId = traceId;
    this.accessToken = accessToken;
  }

  setTraceId = (traceId) => {
    this.traceId = traceId;
  };

  sendInfoLog = async (data) => {
    try {
      await axios.post(this.infoUrl, data, getHeaders(this.traceId, this.accessToken));
    } catch (err) {
      throw new Error('Logservice failed to sendInfoLog', err);
    }
  };

  sendErrorLog = async (data) => {
    try {
      await axios.post(this.errorUrl, data, getHeaders(this.traceId, this.accessToken));
    } catch (err) {
      throw new Error('Logservice failed to sendErrorLog');
    }
  };
}

export default {
  init: (urls, traceId, accessToken) => {
    if (!logInstance) {
      logInstance = new LogService(urls, traceId, accessToken);
    }

    return logInstance;
  },

  getInstance: () => {
    return logInstance;
  },
};
